// components/AgingReportForm.tsx

import { useEffect, useState } from 'react';

import AdvancedRecordTable from '../../../../components/Tables/advancedRecord/AdvancedRecordTable';

import { useCustomer } from '../../../../hooks/useCustomer';

import { useAgingReport } from '../hooks/useAgingReport';

import { AgingFilter } from '../types/aging.types';

import { agingTableColumns } from '../config/agingTableColumns';

import { getAgingTableFilters } from '../config/agingTableFilters';

import AgingSummarySection from './sections/AgingSummarySection';

const AgingReportForm = () => {
  const {
    summary,
    table,
    paginator,
    size,
    loading,
    error,
    fetchAgingSummary,
    fetchAgingTable,
  } = useAgingReport();

  const { handlerGetCustomersForDropdown, customersDropdown } = useCustomer();

  const baseFilter: AgingFilter = {};

  const [filters, setFilters] = useState<AgingFilter>(baseFilter);

  /**
   * 🔍 filtros
   */
  const handleFilterChange = (newFilters: AgingFilter) => {
    const merged = {
      ...baseFilter,
      ...newFilters,
    };

    setFilters(merged);
    fetchAgingTable(merged, 0);
  };

  /**
   * 🔄 reset
   */
  const handleResetFilters = () => {
    setFilters(baseFilter);
    fetchAgingTable(baseFilter, 0);
  };

  /**
   * 📄 paginación
   */
  const handlePageChange = (page: number) => {
    fetchAgingTable(filters, page);
  };

  const handlePageSizeChange = (newSize: number) => {
    fetchAgingTable(filters, 0);
  };

  useEffect(() => {
    fetchAgingSummary();
    fetchAgingTable(baseFilter, 0);

    handlerGetCustomersForDropdown();
  }, []);

  const filterFields = getAgingTableFilters(customersDropdown);

  if (!summary) {
    if (loading) {
      return (
        <p className="py-10 text-center text-sm text-bodydark2">
          Cargando reporte de aging...
        </p>
      );
    }

    return (
      <p className="py-10 text-center text-sm text-danger">
        {error || 'No se pudo cargar el reporte de aging.'}
      </p>
    );
  }

  return (
    <div className="space-y-6">
      {/* 🔹 resumen superior */}
      <AgingSummarySection data={summary} />

      {/* 🔹 tabla paginada */}
      <AdvancedRecordTable
        columns={agingTableColumns}
        data={table}
        paginator={paginator}
        pageSize={size}
        filtersConfig={filterFields}
        onFilterChange={handleFilterChange}
        onResetFilters={handleResetFilters}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
        url="/aging-report-cxc"
        noDataMessage="No hay datos de aging disponibles."
      />
    </div>
  );
};

export default AgingReportForm;
